import React from 'react';

const SuccessMessage = ({ message, onClose }) => {
  return (
    <div style={{
      backgroundColor: '#d4edda',
      color: '#155724',
      padding: '12px 16px',
      borderRadius: '4px',
      marginBottom: '16px',
      border: '1px solid #c3e6cb',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
      <span>{message || 'Operation completed successfully!'}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#155724',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SuccessMessage;
